<p-dialog [(visible)]="visibleYappyModal" [modal]="true" [draggable]="false" [resizable]="false" position="bottom" (onHide)="closeModal()">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2 class="titleFlex"><span>Cuenta</span><i class="yappy-logo"><img src="assets/images/logos/yappy-logo.png" alt="Yappy"></i></h2>
          <p>Yappy wallet</p>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
